export default "__VITE_ASSET__b3a89148__"